import MetaAds from "../../../../contents/docs/cdp/sources/_snippets/source-meta-ads.mdx";
import * as React from 'react';
export default {
  MetaAds,
  React
};